// "Posizionamento viti rispetto ai bordi" card: dimensioned drawing of elements 1 and 2 with the screws and the
// edge-distance table (same content as the report section).
import { useMemo, type FC } from "react";
import { Accordion } from "../../../components/ds2/Accordion";
import type { CalcState } from "../../../http/screwConnector/formulas/state";
import useI18n from "../../../hooks/useTranslations";
import type { ConnectionType } from "../../../http/screwConnector/formulas/types";
import { useCollapsed } from "./useCollapsed";
import { useThreeLabels } from "./labels";
import { positionCardHtml } from "./positionHtml";
import styles from "./PositionCard.module.css";

export type PositionCardProps = {
  state: CalcState | null;
  blockReason?: string | null; // default: state.blocked
  connectionType: ConnectionType;
};

const PositionCard: FC<PositionCardProps> = ({ state, blockReason, connectionType }) => {
  const calc = useI18n().translation.screwConnectorModule.calculation;
  const t = calc.positioning;
  const { positionMeta } = useThreeLabels(connectionType);
  const [collapsed, toggle] = useCollapsed("posCollapsed");
  // generated from numbers and fixed texts only (no user input)
  const html = useMemo(() => positionCardHtml(state, blockReason, calc), [state, blockReason, calc]);
  return (
    <Accordion title={t.title} extra={positionMeta} open={!collapsed} onToggle={toggle}>
      <div className={styles.posContent} dangerouslySetInnerHTML={{ __html: html }} />
    </Accordion>
  );
};

export default PositionCard;
